export default __webpack_public_path__ + "static/media/bremennost-video.b8145066.mp4";